"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _DTOError = _interopRequireDefault(require("../../../errors/DTOError"));

var _usehooksTs = require("usehooks-ts");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Кастомня версия с DTO useReadeLocalStorage из useReadLocalStorage
 * https://usehooks-ts.com/react-hook/use-read-local-storage
 */
var useReadLocalStorageWithDTO = function useReadLocalStorageWithDTO(key, funcDTO) {
  // Get from local storage then
  // parse stored json or return initialValue
  var readValue = (0, _react.useCallback)(function () {
    // Prevent build error "window is undefined" but keep keep working
    if (typeof window === 'undefined') {
      return null;
    }

    try {
      var item = window.localStorage.getItem(key);
      return item ? funcDTO(JSON.parse(item)) : null;
    } catch (err) {
      // пришлось сравнивать по имени тк instanceof не рабоатет видимо из-за сборки в open-api
      if (err instanceof _DTOError["default"]) {
        console.error(err);
        localStorage.removeItem(key);
        return null;
      }

      console.warn("Error reading localStorage key \u201C".concat(key, "\u201D:"), err);
      return null;
    }
  }, [key]); // State to store our value
  // Pass initial state function to useState so logic is only executed once

  var _useState = (0, _react.useState)(readValue),
      _useState2 = _slicedToArray(_useState, 2),
      storedValue = _useState2[0],
      setStoredValue = _useState2[1]; // Listen if localStorage changes


  (0, _react.useEffect)(function () {
    setStoredValue(readValue()); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var handleStorageChange = (0, _react.useCallback)(function (event) {
    if (event !== null && event !== void 0 && event.key && event.key !== key) {
      return;
    }

    setStoredValue(readValue());
  }, [key, readValue]); // this only works for other documents, not the current one

  (0, _usehooksTs.useEventListener)('storage', handleStorageChange); // this is a custom event, triggered in writeValueToLocalStorage
  // See: useLocalStorage()

  (0, _usehooksTs.useEventListener)('local-storage', handleStorageChange);
  return storedValue;
};

var _default = useReadLocalStorageWithDTO;
exports["default"] = _default;